import { render, staticRenderFns } from "./PublicParams.vue?vue&type=template&id=54e8f8f6&scoped=true"
import script from "./PublicParams.vue?vue&type=script&lang=js"
export * from "./PublicParams.vue?vue&type=script&lang=js"
import style0 from "./PublicParams.vue?vue&type=style&index=0&id=54e8f8f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e8f8f6",
  null
  
)

export default component.exports